import { Box, Flex } from "@chakra-ui/react";
import CDS from "design-system";
import Linkify from "./Linkify";

export type InfoEntry = { label: string; value: string | React.ReactNode; linkTo?: string };

export function InfoField({ label, value, linkTo = undefined }: InfoEntry) {
  return (
    <Flex alignItems="flex-start" direction="column">
      <CDS.Text10 color="fg.muted">
        {label}
      </CDS.Text10>
      {typeof value === "string" ? (
        <Linkify linkTo={linkTo}>
          <CDS.Text12 fontWeight="medium" color="chakra-body-text">
            {value}
          </CDS.Text12>
        </Linkify>
      ) : (
        <Linkify linkTo={linkTo}>{value}</Linkify>
      )}
    </Flex>
  );
}

export function InfoSpacer() {
  return (
    <Flex direction="column">
      <Box>&nbsp;</Box>
      <Box>&nbsp;</Box>
    </Flex>
  );
}
